import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BANNER_TYPE, BANNER_ACTIONS } from '@models/banner.class';
@Component({
  selector: 'hb-banner',
  templateUrl: 'banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input() public message: string;
  @Input() public icon: { category: string; name: string };
  @Input() public type: BANNER_TYPE;
  @Output() public bannerActionEmmiter: EventEmitter<string> =
    new EventEmitter();

  public bannerActions = BANNER_ACTIONS;
  public bannerType = BANNER_TYPE;

  constructor() {}

  public bannerAction(action: string): void {
    this.bannerActionEmmiter.emit(action);
  }
}
